import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { ICrudGetProps } from '@monorepo/tools/src/lib/interfaces/crud';
import { IAdminxStore } from '../../stores';
import { useLocation } from 'react-router-dom';

export function useCreativeGroupGet(props: ICrudGetProps) {
	const { id, options } = props;
	const { creativeGroupsStore } = useStores<IAdminxStore>();
	const location = useLocation();

	useEffect(() => {
		if (id) {
			creativeGroupsStore.getCrud().get(id, options);
		}
	}, [location]);

	if (!id) {
		return null;
	}

	return { error: creativeGroupsStore.getCrud().getHttpError(), isLoading: creativeGroupsStore.getCrud().getIsLoading() };
}
